import { render } from "./SectionCardHeader.vue?vue&type=template&id=6d6ccc74"
import script from "./SectionCardHeader.vue?vue&type=script&lang=js"
export * from "./SectionCardHeader.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/LCAP/LCAP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__